import FilterFacets, { FilterSidebar, LAYOUT } from './FilterFacets';

export { FilterSidebar, LAYOUT as FILTER_LAYOUT };
export default FilterFacets;
